import { FormType } from '../../../form-types';
import { MigraineQuestionFieldAnswers } from '../questions';
import { migraineCommon } from './common';

export const migraine2ndLine: FormType<MigraineQuestionFieldAnswers> = {
  name: 'Acute Migraine 2nd Line Questionnaire',
  questions: [
    ...migraineCommon.questions,
    {
      key: 'migraine_nsaidsTried',
      next: {
        condition: { 'migraine_nsaidsTried.not_effective': true },
        key: 'migraine_triptansTried',
        els: 'migraine_nsaidContraindications'
      }
    },
    {
      key: 'migraine_nsaidContraindications',
      next: {
        condition: { 'migraine_nsaidContraindications.yes': true },
        key: 'migraine_triptansTried',
        els: 'generic_ineligible'
      }
    },
    {
      key: 'migraine_triptansTried',
      next: {
        condition: { 'migraine_triptansTried.not_effective': true },
        key: 'generic_ineligible',
        els: 'migraine_triptanContraindications'
      }
    },
    {
      key: 'migraine_triptanContraindications',
      next: {
        condition: { 'migraine_triptanContraindications.yes': true },
        key: 'generic_ineligible',
        els: 'migraine_nauseaVomiting'
      }
    },
    'migraine_nauseaVomiting',
    {
      key: 'migraine_antidepressants',
      next: {
        condition: { 'migraine_antidepressants.yes': true },
        key: 'migraine_serotoninSyndromeAck',
        els: 'migraine_otherInformation'
      }
    },
    {
      key: 'migraine_serotoninSyndromeAck',
      next: {
        condition: { 'migraine_serotoninSyndromeAck.avoid_class': true },
        key: 'generic_ineligible',
        els: 'migraine_otherInformation'
      }
    },
    'migraine_otherInformation',
    {
      key: 'migraine_treatmentConsent',
      next: {
        condition: { 'migraine_treatmentConsent.do_not_continue': true },
        key: 'generic_didNotConsent',
        els: 'generic_complete'
      }
    },
    'generic_complete',
    'generic_ineligible',
    'generic_didNotConsent'
  ]
};
